import React from "react";
import { Check } from "lucide-react";

/**
 * Sidebar list of routine steps with active/done states.
 * Extracted from Routine.jsx to keep that page focused on orchestration.
 */
const RoutineStepsSidebar = ({ steps, activeStep, completed, onSelect }) => (
  <aside
    className="bg-white border border-[#EADDD7] rounded-2xl p-4 h-fit lg:sticky lg:top-28"
    data-testid="routine-steps-sidebar"
  >
    <div className="text-xs uppercase tracking-[0.2em] text-[#8A7D82] px-3 py-2">
      Steps
    </div>
    <ol className="space-y-1">
      {steps.map((s, i) => {
        const isActive = i === activeStep;
        const isDone = completed.has(i);
        return (
          <li key={`${i}-${s.category || "step"}-${s.title || ""}`}>
            <button
              onClick={() => onSelect(i)}
              className={`w-full text-left rounded-xl px-3 py-2.5 flex items-center gap-3 transition-all ${
                isActive ? "bg-[#F2E8E9]" : "hover:bg-[#F5EFEB]"
              }`}
              data-testid={`routine-step-tab-${i}`}
            >
              <span
                className={`h-6 w-6 rounded-full flex items-center justify-center text-xs shrink-0 ${
                  isDone
                    ? "bg-[#9B6A6C] text-white"
                    : isActive
                    ? "bg-white border border-[#9B6A6C] text-[#9B6A6C]"
                    : "bg-[#F5EFEB] text-[#8A7D82]"
                }`}
              >
                {isDone ? <Check className="h-3.5 w-3.5" /> : i + 1}
              </span>
              <span
                className={`text-sm ${
                  isActive
                    ? "text-[#2C2123] font-medium"
                    : "text-[#5C4B51]"
                }`}
              >
                {s.title}
              </span>
            </button>
          </li>
        );
      })}
    </ol>
  </aside>
);

export default RoutineStepsSidebar;
